module.exports = __webpack_public_path__ + "img/189.5f36d8b3.jpg";